// extracted by mini-css-extract-plugin
export var container = "_i0-0";
export var content = "_i0-3";
export var customerTitle = "_i0-4";
export var empty = "_i0-5";
export var gray = "_i0-6";
export var header = "_i0-7";
export var info = "_i0-8";
export var loading = "_i0-2";
export var loadingCard = "_i0-9";
export var oneLine = "_i0-a";
export var personName = "_i0-e";
export var pillContainer = "_i0-b";
export var selected = "_i0-1";
export var text = "_i0-c";
export var twoLines = "_i0-d";
export var unread = "_i0-f";
export var unreadIndicator = "_i0-g";